import { Injectable, inject } from '@angular/core';
import { ConsumerPortalApiService } from './consumer-portal-api.service';
import { Observable, map } from 'rxjs';
import { ContactResponse } from '../admin/interfaces/find-email.interface';
import { AssignOrRevokePermissionRequest, FeatureMapUserAccount } from '../admin/interfaces/user-accout.interface';

@Injectable({
    providedIn: 'root'
})
export class CustomerService {
    private readonly consumerPortalApiService = inject(ConsumerPortalApiService);

    /**
     * Get customer/account contacts
     * @param customerId
     * @returns Observable<ContactResponse[]>
     */
    getCustomerContacts(customerId: string): Observable<ContactResponse[]> {
        return this.consumerPortalApiService.get(`consumers/account/${customerId}/contacts`).pipe(
            map(res => {
                return res;
            })
        ) as unknown as Observable<ContactResponse[]>;
    }

    /**
     * assign or revoke role
     * @param request
     * @returns Observable<FeatureMapUserAccount>
     */
    updateCustomerContactRole(request: AssignOrRevokePermissionRequest): Observable<FeatureMapUserAccount> {
        return this.consumerPortalApiService.patch<AssignOrRevokePermissionRequest>(`user-accounts/assign/roles`, {}, request).pipe(
            map(res => {
                return res;
            })
        ) as unknown as Observable<FeatureMapUserAccount>;
    }
}
